import haileyPic from "@/public/images/artists/hailey.png";
import { Artist } from "@/types/types";

export const hailey = {
  id: "161",
  name: "Hailey",
  image: haileyPic,
  description: `Hailey's voice is bright and melodic, with a clean, processed and mix-ready output that cuts crisply through dance tracks. Her smooth delivery captures the energy needed for EDM and House, with a warm midrange and agile phrasing that brings an uplifting quality to the music.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fhailey-preview2.mp3",
  meta: {
    // Must be free since artist is used in the tutorial
    free: true,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Dance", "Pop", "RnB", "Belting"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 55,
        high: 70,
      },
      sweetSpot: 60,
    },
  },
} as const satisfies Artist;
